/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';

import StatusDropDown from '../StatusDropDown';
import { SelectRole } from '../../../common/SelectRole';
import DateDropDown from '../../common/datedropdown';
import ActionButton from '../../../common/ActionButton';
import SearchBar from '../../common/SearchBar';
import { TUser } from '../../../../types';
import { ApiDropDown, MatchingDropDown } from '../../common/dropdowns';


type TMobileFiltersProps = {
    history: History;
    user: TUser;
    isMobile: boolean;
    onCreate: () => void;
    data: any;
    onFilterChange: () => void;
}

export default function MobileFilters({
    history,
    user,
    isMobile,
    onCreate,
    data,
    onFilterChange,
}: TMobileFiltersProps) {

    const [showFilters, setShowFilters] = useState(false);

    const checkFiltersApplied = (query: any) => {
        const filtersFields = [
            'service',
            'status',
            'role',
            'search',
            'vehicle_type',
            'bookings_client',
        ];
        return filtersFields.find(field => query.get(field) !== null);
    };

    const toggleShowFilters = () => {
        setShowFilters(!showFilters);
    };

    // @ts-ignore
    const currentUrlParams = new URLSearchParams(history.location.search);
    const filtersApplied = checkFiltersApplied(currentUrlParams);

    return (
        <div className="table-filter-container-outer">
            <div className="table-filter-container hidable">
                <div className="table-action-bar filters">
                    <div className="grouped-buttons">
                        <DateDropDown
                            history={history}
                            onFilterChange={onFilterChange}
                            data={data}
                        />
                        {isMobile ? (
                            <ActionButton
                                className="filter"
                                onAction={toggleShowFilters}
                                iconClass="icon-filter-22"
                                text={filtersApplied ? '*' : undefined}
                                active={showFilters}
                                tooltip={
                                    !isMobile
                                        ? showFilters
                                            ? 'Hide Filters'
                                            : 'Filters'
                                        : ''
                                }
                            />
                        ) : null}
                    </div>
                </div>

                <div className="table-action-bar">
                    <div className="grouped-buttons">
                        <ActionButton
                            onAction={() => onCreate()}
                            text={
                                !isMobile
                                    ? user.isClient
                                        ? 'New booking'
                                        : 'Create'
                                    : ''
                            }
                            tooltip={
                                !isMobile
                                    ? user.isClient
                                        ? 'New booking'
                                        : 'Create'
                                    : ''
                            }
                            requiredPermission="job.add_jobrequest"
                            iconClass="icon-add-12"
                        />
                        <ActionButton
                            tooltip="List view"
                            active={true}
                            iconClass="icon-view-list"
                        />
                    </div>
                </div>
            </div>
            {showFilters ? (
                <div className="table-action-bar optional">
                    <StatusDropDown
                        onFilterChange={onFilterChange}
                        history={history}
                    />
                    <SelectRole
                        onFilterChange={onFilterChange}
                        currentUrlParams={currentUrlParams}
                    />
                    {user.isAgent && (
                        <MatchingDropDown
                            onFilterChange={onFilterChange}
                        />
                    )}
                    {user.isAgent && (
                        <ApiDropDown
                            onFilterChange={onFilterChange}
                            currentUrlParams={currentUrlParams}
                            url={`agencies/${user.agency.id}/agents/`}
                            filterKey='consultant'
                            labelKey='full_name'
                            valueKey='id'
                            verboseNamePlural='consultants'
                        />
                    )}
                    {user.isAgent && (
                        <ApiDropDown
                            onFilterChange={onFilterChange}
                            currentUrlParams={currentUrlParams}
                            url='cost-centres/'
                            filterKey='cost_centre'
                            labelKey='code'
                            valueKey='id'
                            verboseNamePlural='cost centres'
                        />
                    )}
                    <SearchBar
                        filterKey="search"
                        onFilterChange={onFilterChange}
                        currentUrlParams={currentUrlParams}
                    />
                    <SearchBar
                        filterKey="series"
                        onFilterChange={onFilterChange}
                        currentUrlParams={currentUrlParams}
                        customPlaceHolder="Search for series..."
                        isSearchBySeries={true}
                    />
                </div>
            ) : null}
        </div>
    );
}
